@if (order === refDatumOrder.column) {
  <div class="desktop-only">
    <ul [formGroup]="form" [ngStyle]="{'height.px': ulHeight}">
      @for (item of refDatumItems; track item.id) {
        <li>
          <iris-checkbox
            [formControlName]="item.id.toString()"
            [attr.data-test]="'list-checkbox-' + item.title"
          >
            {{ item.title }}
          </iris-checkbox>
        </li>
      }
    </ul>
  </div>
}

@if (order === refDatumOrder.row) {
  <div class="desktop-only">
    <mat-grid-list
      [cols]="columns"
      rowHeight="45px"
      class="marginBtm10"
      [formGroup]="form"
    >
      @for (item of refDatumItems; track item.id) {
        <mat-grid-tile colspan="1" rowspan="1">
          <div class="text-inside-grid">
            <iris-checkbox
              [formControlName]="item.id.toString()"
              [attr.data-test]="'grid-checkbox-' + item.title"
            >
              {{ item.title }}
            </iris-checkbox>
          </div>
        </mat-grid-tile>
      }
    </mat-grid-list>
  </div>
}

<div class="mobile-only">
  <form [formGroup]="form">
    <mat-selection-list (selectionChange)="onSelectionChange($event)">
      @for (item of refDatumItems; track item.id) {
        <mat-list-option togglePosition="before" [value]="item.id.toString()" [selected]="form.get(item.id.toString())?.value">
          <span matListItemTitle>{{ item.title }}</span>
        </mat-list-option>
      }
    </mat-selection-list>
  </form>
</div>
